import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { ButtonReset } from '@helpers/global';
import { siteWide } from '@helpers/grid';
import { Layers } from '@helpers/layers';
import { paragraphRegular } from '@helpers/typography';
import styled from 'styled-components';
const Container = styled.div `
  ${siteWide};

  position: relative;
  z-index: ${Layers.NavigationTray + 1};
  height: 0;
`;
const Button = styled.button `
  ${ButtonReset};
  ${transition('opacity, transform')};
  ${paragraphRegular};

  position: absolute;
  left: 0;
  top: 0;
  margin: 0;
  opacity: 0;
  transform: translate(3px, -100%);
  background-color: var(--fgColour, ${brand.primary.offWhite});
  color: var(--bgColour, ${brand.primary.purple});
  padding: 8px 12px;

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-style: solid;
    outline-width: 2px;
    outline-color: var(--fgColour, ${brand.primary.offWhite});
    opacity: 1;
    transform: translate(3px, 3px);
  }
`;
const SkipLinkStyles = {
    Container,
    Button,
};
export default SkipLinkStyles;
